import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgLogoKb = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 160 150",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M107 53.4V40h-.6c-11.1.5-20.3 7.7-26 13.4l-.3.3-.3-.3C74 47.7 64.8 40.5 53.6 40H53v13.4H40v23.1c0 5.6.2 11.2.6 15.8.8 9.3 8.2 16.4 17.3 17 7.1.4 14.6.7 22.1.7s15-.3 22.1-.8c9.1-.7 16.5-7.8 17.3-17 .4-4.6.6-10.2.6-15.8v-23h-13zm0 23.1c0 5.3-.2 10.5-.6 14.7-.2 2.7-2.4 4.9-5.2 5-13.6 1-28.8 1-42.4 0-2.9-.2-5-2.4-5.2-5-.4-4.2-.6-9.5-.6-14.7V53.4c9.4.4 18.8 10.4 21.6 14.4l5.4 7.5 5.4-7.5c2.8-4 12.2-14 21.6-14.4v23.1z",
		fill: "#9146ff"
	})
});
export default SvgLogoKb;
